import React from 'react';
import Button from '../../../components/Button';

export default ({ item }) => {
	return (
		<>
			<div className="py-6">
				<div className="flex justify-end">
					<Button onClick={() => {}}>Manage</Button>
				</div>

				{item?.contracts?.length ? (
					<div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
						{item?.contracts?.map((contract) => (
							<div>{JSON.stringify(contract)}</div>
						))}
					</div>
				) : (
					<p className="text-center py-12 text-gray-600">No contracts added</p>
				)}
			</div>
		</>
	);
};
